<template>
  <div class="tv-row">
    <div v-quick-title="team.title" class="tv-col name clickable" @click="$emit('teamClicked', team.id)">
      {{ decodeHTML(team.name) }}
    </div>
    <div class="tv-col value clickable" @click="$emit('valueClick')">
      {{ valColumn }}
    </div>
    <div
      v-if="displayScoreColumn"
      v-quick-title="dispScoreDiff"
      class="tv-col score clickable"
      :class="scoreSpanClasses"
      @click="$emit('scoreClick')"
    >
      <div class="variation-wrapper">
        <span class="score-value" :class="scoreSpanClasses">{{ scoreColumn }}</span>
        <div v-if="scoreDiff !== 0" class="variation-indicator">
          <Icon v-if="scoreDiff > 0" class="up">
            {{ arrowUpFill }}
          </Icon>
          <Icon v-else class="down">
            {{ arrowDownLine }}
          </Icon>
          <span>{{ scoreDiff.sToFixed(1) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vitality Hub criterion table row.
 * Row content of a Criterion table which displays details of teams about a specific piece of data
 */

// Components
import Icon from '@/components/icon.vue';
// Utils
import { decodeHTML } from '@/utils/main';
import { arrowDownLine, arrowUpFill } from '@/assets/icons';

export default {
  name: 'VHCriterionTableRow',

  components: {
    Icon,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },
    criterion: {
      type: Object,
      required: true,
    },
    displayScoreColumn: Boolean,
  },

  data() {
    return {
      arrowDownLine,
      arrowUpFill,
    };
  },

  computed: {
    scoreData() {
      const { scoresKey } = this.criterion;
      return this.team[scoresKey] ? this.team[scoresKey][0] : { score: 0, data: { value: 0 } };
    },
    /** String: text-formatted value column */
    valColumn() {
      return this.criterion.text(this.scoreData.data);
    },
    /** String: formatted score */
    scoreColumn() {
      return this.scoreData.score.sToFixed(1);
    },
    /** Number: Score difference between current period and last period */
    scoreDiff() {
      const { scoresKey } = this.criterion;
      if (this.team[scoresKey]) {
        return this.team[scoresKey][0].score - this.team[scoresKey][1].score;
      }
      return 0;
    },
    dispScoreDiff() {
      const abs = Math.abs(this.scoreDiff);
      if (this.scoreDiff > 0) {
        return this.$tc('message.VH_POINT_INCREASE', abs, { val: abs.sToFixed(1) });
      }
      if (this.scoreDiff < 0) {
        return this.$tc('message.VH_POINT_DECREASE', abs, { val: abs.sToFixed(1) });
      }
      return '';
    },
    /** Object: Classes to apply to the score span */
    scoreSpanClasses() {
      if (this.scoreData.score > 50) {
        return 'good';
      }
      if (this.scoreData.score < 40) {
        return 'bad';
      }
      return 'okay';
    },
  },

  methods: {
    decodeHTML,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
// Some style in criterion-table.vue

.vitality-hub .vhcp-criterion-table .tv-rows .tv-row {
  flex-flow: row wrap;
}
</style>
